module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Tools/Brush-b6349200ccd6a8fff40bc21876eb81b9a3584be83a47f88fa5567425d5f2f0a6.svg";